import React from 'react';
import { Star, Quote } from 'lucide-react';
interface ReviewCardProps {
  quote: string;
  name: string;
  label: string;
}
export function ReviewCard({
  quote,
  name,
  label
}: ReviewCardProps) {
  return <div className="bg-paper p-8 rounded-2xl shadow-soft border border-subtle-gray relative" data-id="element-238">
      <Quote className="absolute top-8 right-8 w-12 h-12 text-subtle-gray opacity-50" data-id="element-239" />
      <div className="flex gap-1 text-gold mb-6" data-id="element-240">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5" fill="currentColor" data-id="element-241" />)}
      </div>
      <p className="text-lg text-ink font-medium mb-8 relative z-10" data-id="element-242">
        "{quote}"
      </p>
      <div className="flex items-center gap-4" data-id="element-243">
        <div className="w-12 h-12 bg-charcoal rounded-full flex items-center justify-center text-white font-display text-xl" data-id="element-244">
          {name.charAt(0)}
        </div>
        <div data-id="element-245">
          <p className="font-bold text-ink" data-id="element-246">{name}</p>
          <p className="text-sm text-storm-red font-bold uppercase tracking-wide" data-id="element-247">
            {label}
          </p>
        </div>
      </div>
    </div>;
}